import { useState } from "react";
import { Box, Modal, Table, TableBody, TableContainer, TableHead, TableRow, Typography, useTheme } from "@mui/material";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import HelpIcon from "@mui/icons-material/Help";
import CancelIcon from "@mui/icons-material/Cancel";
import { Link, useParams, useSearchParams } from "react-router-dom";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ProjectHelperDetail from "./ProjectHelperDetail";
import Popup from "./TurnedOffPopUp";
import MainLoader from "../MainLoader/MainLoader";
import { validateNumber } from "./common/utils";
const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(odd)": {
    // backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.text.primary,
    fontWeight: 600,
    fontSize: "15px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const Modelstyle = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 630,
  backgroundColor: theme.palette.background.default,
  padding: "40px 50px 45px",
  borderRadius: "20px",
  boxShadow: "0 0 1px 0 rgba(0,0,0,0.31), 0 24px 36px -8px rgba(0,0,0,0.25)",
  "@media screen and (max-width:600px)": {
    width: "90%",
    padding: "40px 24px 45px",
  },
  "& > svg": {
    position: "absolute",
    top: "22px",
    right: "22px",
    color: theme.palette.primary.main,

    cursor: "pointer",
  },
}));
const TableMainWrapper = styled(Box)(({ theme }) => ({
  "& table": {
    marginTop: "0",
    borderRadius: "12px",
    // overflow: "hidden",
    borderBottomLeftRadius: "0",
    borderBottomRightRadius: "0",
    "& thead": {
      "& tr th.MuiTableCell-head": {
        backgroundColor: theme.palette.common.hoverBtn,
        fontSize: "14px",
      },
    },
    "& tbody": {
      "& tr td": {
        color: theme.palette.text.primary,
        padding: "0px 5px",
        "& a": {
          color: theme.palette.text.primary,
          fontWeight: 600,
          "& svg": {
            color: "red",
          },
        },
        "& .HelperIconStyle": {
          color: `${theme.palette.primary.main} !important`,
          transition: "0.3s all",
          cursor: "pointer",
          "&:hover": { color: "#ff642d" },
        },
        "& .MoreIconStyle": {
          color: theme.palette.primary.main,

          cursor: "pointer",
        },
      },

      "& > h5": {
        fontSize: "16px",
        fontWeight: 600,
        padding: "12px 14px 12px",
        color: theme.palette.text.primary,
      },
      "& .indexable": {
        color: theme.palette.text.primary,
        fontWeight: 600,

        fontSize: "12px",
        paddingLeft: "14px",
        fontFamily: "Plus Jakarta Sans', sans-serif !important",
        display: "inline-block",
      },
      "& .Indexability": {
        color: theme.palette.common.black,
        fontSize: "15px",
      },
      "& .Indexabilitylink": {
        fontSize: "15px",
        color: theme.palette.primary.main,
      },
    },
  },
}));

const BoxCss = { opacity: 0.5, pointerEvents: "none" };
function ProjectDetailData({
  internalPageCount,
  indexableCount,
  nonIndexableCount,
  indexableContentCount,
  nonIndexableContentCount,
  socialTagCountPrepaired,
  imageTagCountPrepaired,
  jsCountPrepaired,
  cssTagCountPrepaired,
  externalPagesCountPrepaired,
  internalLinkPage,
  refresh,
  issueBtnIndx,
  duplicatePageCount,
  totalCount = 0,
  redirectCount,
}) {
  const [newState, setNewState] = useState({ open: false, flag: "", viewLink: "", val: 0 });
  const handleOpen = ({ flag, viewLink, val }) => {
    setNewState({ ...newState, open: true, flag, viewLink, val });
  };
  const handleClose = () => setNewState({ ...newState, open: false });
  const params = useParams();
  const [searchParams] = useSearchParams();
  const theme = useTheme();
  const projectdetailtable = {
    maxHeight: "calc(100vh - 100px)",
    "&::-webkit-scrollbar-track": {
      // WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.3)",
      borderRadius: "10px",
      backgroundColor: theme.palette.text.primary + "0d",
    },
    "&::-webkit-scrollbar": { width: "8px", backgroundColor: "transparent" },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
      WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,.3)",
      backgroundColor: theme.palette.primary.main,
    },
    "& .countColor": {
      color: "red",
    },
  };
  return (
    <TableMainWrapper sx={{ maxHeight: 440, overflow: "auto", height: 400 }}>
      {totalCount < 1 ? (
        <MainLoader message="Loading" />
      ) : (
        <TableContainer sx={projectdetailtable}>
          <Table sx={{ minWidth: 700, marginTop: 5 }} stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <StyledTableCell align="left">Issue</StyledTableCell>
                <StyledTableCell align="right">Crawled</StyledTableCell>
                <StyledTableCell align="right">Change</StyledTableCell>
                <StyledTableCell align="right">Added</StyledTableCell>
                <StyledTableCell align="right">New</StyledTableCell>
                <StyledTableCell align="right">Removed</StyledTableCell>
                <StyledTableCell align="right">Missing</StyledTableCell>
                <StyledTableCell align="right"></StyledTableCell>
                <StyledTableCell align="right"></StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <>
                {internalLinkPage?.length > 0 && <Typography component="h5">Internal pages</Typography>}
                {internalLinkPage &&
                  internalLinkPage.map(linkData => {
                    const totalAdded = validateNumber(linkData?.addIssue || 0) + validateNumber(linkData?.newIssue || 0);
                    const totalRemoved = validateNumber(linkData?.removeIssue || 0);

                    const priorityColor = totalRemoved > totalAdded ? "green" : totalRemoved < totalAdded ? "red" : "inherit";
                    return (
                      <StyledTableRow key={Math.random().toString(36).substr(2, 9)}>
                        <StyledTableCell align="left">
                          {linkData?.count > 0 ? (
                            <Link to={`/project-inner-detail/${params?.sessionId}/${linkData?.flag}&internalPage?name=${linkData?.content}&origin=${searchParams.get("origin")}`}>
                              {linkData?.icon}
                              <Typography component="span" className="Indexabilitylink">
                                {" "}
                                {linkData?.content}
                              </Typography>
                            </Link>
                          ) : (
                            <Box component="span" sx={BoxCss}>
                              {linkData?.icon}
                              <Typography component="span" className="Indexability">
                                {" "}
                                {linkData?.content}
                              </Typography>
                            </Box>
                          )}
                        </StyledTableCell>
                        <StyledTableCell align="right">{linkData?.count}</StyledTableCell>

                        <StyledTableCell align="right">
                          <Typography
                            style={{
                              color: priorityColor,
                            }}
                          >
                            {linkData?.changeCount}
                            {totalRemoved < totalAdded ? (
                              <ArrowDropUpIcon style={{ color: priorityColor }} />
                            ) : totalRemoved > totalAdded ? (
                              <ArrowDropDownIcon style={{ color: priorityColor }} />
                            ) : null}
                          </Typography>
                        </StyledTableCell>

                        <StyledTableCell align="right">
                          <Typography
                            style={{
                              color: linkData?.addIssue > 0 ? "red" : linkData?.addIssue < 0 ? "green" : "inherit",
                            }}
                          >
                            {linkData?.addIssue}
                          </Typography>
                        </StyledTableCell>

                        <StyledTableCell align="right">
                          <Typography
                            style={{
                              color: linkData?.newIssue > 0 ? "red" : "inherit",
                            }}
                          >
                            {linkData?.newIssue}
                          </Typography>
                        </StyledTableCell>

                        <StyledTableCell align="right">
                          <Typography
                            style={{
                              color: linkData?.removeIssue > 0 ? "green" : linkData?.removeIssue < 0 ? "red" : "inherit",
                            }}
                          >
                            {linkData?.removeIssue}
                          </Typography>
                        </StyledTableCell>
                        <StyledTableCell align="right">—</StyledTableCell>

                        <StyledTableCell align="right">
                          <HelpIcon
                            onClick={() =>
                              handleOpen({
                                flag: linkData?.flag,
                                viewLink: `/project-inner-detail/${params?.sessionId}/${linkData?.flag}&internalPage?name=${linkData?.content}&origin=${searchParams.get(
                                  "origin",
                                )}`,
                                val: linkData?.count,
                              })
                            }
                            className="HelperIconStyle"
                          />
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          <Popup flag={`${linkData?.flag}&internalPage`} refresh={refresh} issueBtnIndx={issueBtnIndx} updateFlag={linkData?.flag} />
                        </StyledTableCell>
                      </StyledTableRow>
                    );
                  })}
              </>
              {internalPageCount?.length > 0 && <Typography component="h5">Indexability</Typography>}
              {internalPageCount &&
                internalPageCount.map(internalPages => {
                  const totalAdded = validateNumber(internalPages?.addIssue || 0) + validateNumber(internalPages?.newIssue || 0);
                  const totalRemoved = validateNumber(internalPages?.removeIssue || 0);

                  const priorityColor = totalRemoved > totalAdded ? "green" : totalRemoved < totalAdded ? "red" : "inherit";

                  return (
                    <StyledTableRow key={Math.random().toString(36).substr(2, 9)}>
                      <StyledTableCell align="left">
                        {internalPages?.count > 0 ? (
                          <Link
                            to={`/project-inner-detail/${params?.sessionId}/${internalPages?.flag}&Indexability?name=${internalPages?.content}&origin=${searchParams.get(
                              "origin",
                            )}`}
                          >
                            {internalPages?.icon}
                            <Typography component="span" className="Indexabilitylink">
                              {" "}
                              {internalPages?.content}
                            </Typography>
                          </Link>
                        ) : (
                          <Box component="span" sx={BoxCss}>
                            {internalPages?.icon}
                            <Typography component="span" className="Indexability">
                              {" "}
                              {internalPages?.content}
                            </Typography>
                          </Box>
                        )}
                      </StyledTableCell>
                      <StyledTableCell align="right">{internalPages?.count}</StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: priorityColor,
                          }}
                        >
                          {internalPages?.changeCount}
                          {totalRemoved < totalAdded ? (
                            <ArrowDropUpIcon style={{ color: priorityColor }} />
                          ) : totalRemoved > totalAdded ? (
                            <ArrowDropDownIcon style={{ color: priorityColor }} />
                          ) : null}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: internalPages?.addIssue > 0 ? "red" : internalPages?.addIssue < 0 ? "green" : "inherit",
                          }}
                        >
                          {internalPages?.addIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: internalPages?.newIssue > 0 ? "red" : "inherit",
                          }}
                        >
                          {internalPages?.newIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: internalPages?.removeIssue > 0 ? "green" : internalPages?.removeIssue < 0 ? "red" : "inherit",
                          }}
                        >
                          {internalPages?.removeIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">—</StyledTableCell>

                      <StyledTableCell align="right">
                        <HelpIcon
                          onClick={() =>
                            handleOpen({
                              flag: internalPages?.flag,
                              viewLink: `/project-inner-detail/${params?.sessionId}/${internalPages?.flag}&Indexability?name=${internalPages?.content}&origin=${searchParams.get(
                                "origin",
                              )}`,
                              val: internalPages?.count,
                            })
                          }
                          className="HelperIconStyle"
                        />
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <Popup flag={`${internalPages?.flag}&Indexability`} refresh={refresh} issueBtnIndx={issueBtnIndx} updateFlag={internalPages?.flag} />
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}

              {(indexableCount?.length > 0 || nonIndexableCount?.length > 0) && <Typography component="h5">Links</Typography>}
              {indexableCount?.length > 0 && (
                <Typography component="span" className="indexable">
                  INDEXABLE
                </Typography>
              )}
              {indexableCount &&
                indexableCount.map(linksIndexData => {
                  const totalAdded = validateNumber(linksIndexData?.addIssue || 0) + validateNumber(linksIndexData?.newIssue || 0);
                  const totalRemoved = validateNumber(linksIndexData?.removeIssue || 0);

                  const priorityColor = totalRemoved > totalAdded ? "green" : totalRemoved < totalAdded ? "red" : "inherit";
                  return (
                    <StyledTableRow key={Math.random().toString(36).substr(2, 9)}>
                      <StyledTableCell align="left">
                        {linksIndexData?.count > 0 ? (
                          <Link
                            to={`/project-inner-detail/${params?.sessionId}/${linksIndexData?.flag}&Links&indexable?name=${linksIndexData?.content}&origin=${searchParams.get(
                              "origin",
                            )}`}
                          >
                            {linksIndexData?.icon}
                            <Typography component="span" className="Indexabilitylink">
                              {" "}
                              {linksIndexData?.content}
                            </Typography>
                          </Link>
                        ) : (
                          <Box component="span" sx={BoxCss}>
                            {linksIndexData?.icon}
                            <Typography component="span" className="Indexability">
                              {" "}
                              {linksIndexData?.content}
                            </Typography>
                          </Box>
                        )}
                      </StyledTableCell>
                      <StyledTableCell align="right">{linksIndexData?.count}</StyledTableCell>
                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: priorityColor,
                          }}
                        >
                          {linksIndexData?.changeCount}
                          {totalRemoved < totalAdded ? (
                            <ArrowDropUpIcon style={{ color: priorityColor }} />
                          ) : totalRemoved > totalAdded ? (
                            <ArrowDropDownIcon style={{ color: priorityColor }} />
                          ) : null}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: linksIndexData?.addIssue > 0 ? "red" : linksIndexData?.addIssue < 0 ? "green" : "inherit",
                          }}
                        >
                          {linksIndexData?.addIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: linksIndexData?.newIssue > 0 ? "red" : "inherit",
                          }}
                        >
                          {linksIndexData?.newIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: linksIndexData?.removeIssue > 0 ? "green" : linksIndexData?.removeIssue < 0 ? "red" : "inherit",
                          }}
                        >
                          {linksIndexData?.removeIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">—</StyledTableCell>
                      <StyledTableCell align="right">
                        <HelpIcon
                          onClick={() =>
                            handleOpen({
                              flag: linksIndexData?.flag,
                              viewLink: `/project-inner-detail/${params?.sessionId}/${linksIndexData?.flag}&Links&indexable?name=${
                                linksIndexData?.content
                              }&origin=${searchParams.get("origin")}`,
                              val: linksIndexData?.count,
                            })
                          }
                          className="HelperIconStyle"
                        />
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {" "}
                        <Popup flag={`${linksIndexData?.flag}&Links&indexable`} refresh={refresh} issueBtnIndx={issueBtnIndx} updateFlag={linksIndexData?.flag} />
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
              {nonIndexableCount?.length > 0 && (
                <Typography component="span" className="indexable">
                  NOT INDEXABLE
                </Typography>
              )}
              {nonIndexableCount &&
                nonIndexableCount.map(linksNonIndexData => {
                  const totalAdded = validateNumber(linksNonIndexData?.addIssue || 0) + validateNumber(linksNonIndexData?.newIssue || 0);
                  const totalRemoved = validateNumber(linksNonIndexData?.removeIssue || 0);

                  const priorityColor = totalRemoved > totalAdded ? "green" : totalRemoved < totalAdded ? "red" : "inherit";
                  return (
                    <StyledTableRow key={Math.random().toString(36).substr(2, 9)}>
                      <StyledTableCell align="left">
                        {linksNonIndexData?.count > 0 ? (
                          <Link
                            to={`/project-inner-detail/${params?.sessionId}/${linksNonIndexData?.flag}&Links&notIndexable?name=${
                              linksNonIndexData?.content
                            }&origin=${searchParams.get("origin")}`}
                          >
                            {linksNonIndexData?.icon}
                            <Typography component="span" className="Indexabilitylink">
                              {" "}
                              {linksNonIndexData?.content}
                            </Typography>
                          </Link>
                        ) : (
                          <Box component="span" sx={BoxCss}>
                            {linksNonIndexData?.icon}
                            <Typography component="span" className="Indexability">
                              {" "}
                              {linksNonIndexData?.content}
                            </Typography>
                          </Box>
                        )}
                      </StyledTableCell>
                      <StyledTableCell align="right">{linksNonIndexData?.count}</StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: priorityColor,
                          }}
                        >
                          {linksNonIndexData?.changeCount}
                          {totalRemoved < totalAdded ? (
                            <ArrowDropUpIcon style={{ color: priorityColor }} />
                          ) : totalRemoved > totalAdded ? (
                            <ArrowDropDownIcon style={{ color: priorityColor }} />
                          ) : null}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: linksNonIndexData?.addIssue > 0 ? "red" : linksNonIndexData?.addIssue < 0 ? "green" : "inherit",
                          }}
                        >
                          {linksNonIndexData?.addIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: linksNonIndexData?.newIssue > 0 ? "red" : "inherit",
                          }}
                        >
                          {linksNonIndexData?.newIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: linksNonIndexData?.removeIssue > 0 ? "green" : linksNonIndexData?.removeIssue < 0 ? "red" : "inherit",
                          }}
                        >
                          {linksNonIndexData?.removeIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">—</StyledTableCell>
                      <StyledTableCell align="right">
                        <HelpIcon
                          onClick={() =>
                            handleOpen({
                              flag: linksNonIndexData?.flag,
                              viewLink: `/project-inner-detail/${params?.sessionId}/${linksNonIndexData?.flag}&Links&notIndexable?name=${
                                linksNonIndexData?.content
                              }&origin=${searchParams.get("origin")}`,
                              val: linksNonIndexData?.count,
                            })
                          }
                          className="HelperIconStyle"
                        />
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {" "}
                        <Popup flag={`${linksNonIndexData?.flag}&Links&notIndexable`} refresh={refresh} issueBtnIndx={issueBtnIndx} updateFlag={linksNonIndexData?.flag} />
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}

              {redirectCount?.length > 0 && <Typography component="h5">Redirect</Typography>}
              {redirectCount &&
                redirectCount.map(redirectData => {
                  const totalAdded = validateNumber(redirectData?.addIssue || 0) + validateNumber(redirectData?.newIssue || 0);
                  const totalRemoved = validateNumber(redirectData?.removeIssue || 0);

                  const priorityColor = totalRemoved > totalAdded ? "green" : totalRemoved < totalAdded ? "red" : "inherit";
                  return (
                    <StyledTableRow key={Math.random().toString(36).substr(2, 9)}>
                      <StyledTableCell align="left">
                        {redirectData?.count > 0 ? (
                          <Link
                            to={`/project-inner-detail/${params?.sessionId}/${redirectData?.flag}&redirectFlag?name=${redirectData?.content}&origin=${searchParams.get("origin")}`}
                          >
                            {redirectData?.icon}
                            <Typography component="span" className="Indexabilitylink">
                              {" "}
                              {redirectData?.content}
                            </Typography>
                          </Link>
                        ) : (
                          <Box component="span" sx={BoxCss}>
                            {redirectData?.icon}
                            <Typography component="span" className="Indexability">
                              {" "}
                              {redirectData?.content}
                            </Typography>
                          </Box>
                        )}
                      </StyledTableCell>

                      <StyledTableCell align="right">{redirectData?.count}</StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: priorityColor,
                          }}
                        >
                          {redirectData?.changeCount}
                          {totalRemoved < totalAdded ? (
                            <ArrowDropUpIcon style={{ color: priorityColor }} />
                          ) : totalRemoved > totalAdded ? (
                            <ArrowDropDownIcon style={{ color: priorityColor }} />
                          ) : null}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: redirectData?.addIssue > 0 ? "red" : redirectData?.addIssue < 0 ? "green" : "inherit",
                          }}
                        >
                          {redirectData?.addIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: redirectData?.newIssue > 0 ? "red" : "inherit",
                          }}
                        >
                          {redirectData?.newIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: redirectData?.removeIssue > 0 ? "green" : redirectData?.removeIssue < 0 ? "red" : "inherit",
                          }}
                        >
                          {redirectData?.removeIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">—</StyledTableCell>

                      <StyledTableCell align="right">
                        <HelpIcon
                          onClick={() =>
                            handleOpen({
                              flag: redirectData?.flag,
                              viewLink: `/project-inner-detail/${params?.sessionId}/${redirectData?.flag}&redirectFlag?name=${redirectData?.content}&origin=${searchParams.get(
                                "origin",
                              )}`,
                              val: redirectData?.count,
                            })
                          }
                          className="HelperIconStyle"
                        />
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <Popup flag={`${redirectData?.flag}&redirectFlag`} refresh={refresh} issueBtnIndx={issueBtnIndx} updateFlag={redirectData?.flag} />
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}

              {(indexableContentCount?.length > 0 || nonIndexableContentCount?.length > 0) && <Typography component="h5">Content</Typography>}
              {indexableContentCount?.length > 0 && (
                <Typography component="span" className="indexable">
                  INDEXABLE
                </Typography>
              )}
              {indexableContentCount &&
                indexableContentCount.map(contentIndexData => {
                  const totalAdded = validateNumber(contentIndexData?.addIssue || 0) + validateNumber(contentIndexData?.newIssue || 0);
                  const totalRemoved = validateNumber(contentIndexData?.removeIssue || 0);

                  const priorityColor = totalRemoved > totalAdded ? "green" : totalRemoved < totalAdded ? "red" : "inherit";
                  return (
                    <StyledTableRow key={Math.random().toString(36).substr(2, 9)}>
                      <StyledTableCell align="left">
                        {contentIndexData?.count > 0 ? (
                          <Link
                            to={`/project-inner-detail/${params?.sessionId}/${contentIndexData?.flag}&content&indexable?name=${contentIndexData?.content}&origin=${searchParams.get(
                              "origin",
                            )}`}
                          >
                            {contentIndexData?.icon}
                            <Typography component="span" className="Indexabilitylink">
                              {" "}
                              {contentIndexData?.content}
                            </Typography>
                          </Link>
                        ) : (
                          <Box component="span" sx={BoxCss}>
                            {contentIndexData?.icon}
                            <Typography component="span" className="Indexability">
                              {" "}
                              {contentIndexData?.content}
                            </Typography>
                          </Box>
                        )}
                      </StyledTableCell>

                      <StyledTableCell align="right">{contentIndexData?.count}</StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: priorityColor,
                          }}
                        >
                          {contentIndexData?.changeCount}
                          {totalRemoved < totalAdded ? (
                            <ArrowDropUpIcon style={{ color: priorityColor }} />
                          ) : totalRemoved > totalAdded ? (
                            <ArrowDropDownIcon style={{ color: priorityColor }} />
                          ) : null}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: contentIndexData?.addIssue > 0 ? "red" : contentIndexData?.addIssue < 0 ? "green" : "inherit",
                          }}
                        >
                          {contentIndexData?.addIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: contentIndexData?.newIssue > 0 ? "red" : "inherit",
                          }}
                        >
                          {contentIndexData?.newIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: contentIndexData?.removeIssue > 0 ? "green" : contentIndexData?.removeIssue < 0 ? "red" : "inherit",
                          }}
                        >
                          {contentIndexData?.removeIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">—</StyledTableCell>

                      <StyledTableCell align="right">
                        <HelpIcon
                          onClick={() =>
                            handleOpen({
                              flag: contentIndexData?.flag,
                              viewLink: `/project-inner-detail/${params?.sessionId}/${contentIndexData?.flag}&content&indexable?name=${
                                contentIndexData?.content
                              }&origin=${searchParams.get("origin")}`,
                              val: contentIndexData?.count,
                            })
                          }
                          className="HelperIconStyle"
                        />
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {" "}
                        <Popup flag={`${contentIndexData?.flag}&content&indexable`} refresh={refresh} issueBtnIndx={issueBtnIndx} updateFlag={contentIndexData?.flag} />
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
              {nonIndexableContentCount?.length > 0 && (
                <Typography component="span" className="indexable">
                  NOT INDEXABLE
                </Typography>
              )}
              {nonIndexableContentCount &&
                nonIndexableContentCount.map(contentNonIndex => {
                  const totalAdded = validateNumber(contentNonIndex?.addIssue || 0) + validateNumber(contentNonIndex?.newIssue || 0);
                  const totalRemoved = validateNumber(contentNonIndex?.removeIssue || 0);

                  const priorityColor = totalRemoved > totalAdded ? "green" : totalRemoved < totalAdded ? "red" : "inherit";
                  return (
                    <StyledTableRow key={Math.random().toString(36).substr(2, 9)}>
                      <StyledTableCell align="left">
                        {contentNonIndex?.count > 0 ? (
                          <Link
                            to={`/project-inner-detail/${params.sessionId}/${contentNonIndex?.flag}&content&nonIndexable?name=${contentNonIndex?.content}&origin=${searchParams.get(
                              "origin",
                            )}`}
                          >
                            {contentNonIndex?.icon}
                            <Typography component="span" className="Indexabilitylink">
                              {" "}
                              {contentNonIndex?.content}
                            </Typography>
                          </Link>
                        ) : (
                          <Box component="span" sx={BoxCss}>
                            {contentNonIndex?.icon}
                            <Typography component="span" className="Indexability">
                              {" "}
                              {contentNonIndex?.content}
                            </Typography>
                          </Box>
                        )}
                      </StyledTableCell>

                      <StyledTableCell align="right">{contentNonIndex?.count}</StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: priorityColor,
                          }}
                        >
                          {contentNonIndex?.changeCount}
                          {totalRemoved < totalAdded ? (
                            <ArrowDropUpIcon style={{ color: priorityColor }} />
                          ) : totalRemoved > totalAdded ? (
                            <ArrowDropDownIcon style={{ color: priorityColor }} />
                          ) : null}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: contentNonIndex?.addIssue > 0 ? "red" : contentNonIndex?.addIssue < 0 ? "green" : "inherit",
                          }}
                        >
                          {contentNonIndex?.addIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: contentNonIndex?.newIssue > 0 ? "red" : "inherit",
                          }}
                        >
                          {contentNonIndex?.newIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: contentNonIndex?.removeIssue > 0 ? "green" : contentNonIndex?.removeIssue < 0 ? "red" : "inherit",
                          }}
                        >
                          {contentNonIndex?.removeIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">—</StyledTableCell>

                      <StyledTableCell align="right">
                        <HelpIcon
                          onClick={() =>
                            handleOpen({
                              flag: contentNonIndex?.flag,
                              viewLink: `/project-inner-detail/${params.sessionId}/${contentNonIndex?.flag}&content&nonIndexable?name=${
                                contentNonIndex?.content
                              }&origin=${searchParams.get("origin")}`,
                              val: contentNonIndex?.count,
                            })
                          }
                          className="HelperIconStyle"
                        />
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <Popup flag={`${contentNonIndex?.flag}&content&nonIndexable`} refresh={refresh} issueBtnIndx={issueBtnIndx} updateFlag={contentNonIndex?.flag} />
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
              {socialTagCountPrepaired?.length > 0 && <Typography component="h5">Social tags</Typography>}
              {socialTagCountPrepaired &&
                socialTagCountPrepaired.map(tagsData => {
                  const totalAdded = validateNumber(tagsData?.addIssue || 0) + validateNumber(tagsData?.newIssue || 0);
                  const totalRemoved = validateNumber(tagsData?.removeIssue || 0);

                  const priorityColor = totalRemoved > totalAdded ? "green" : totalRemoved < totalAdded ? "red" : "inherit";
                  return (
                    <StyledTableRow key={Math.random().toString(36).substr(2, 9)}>
                      <StyledTableCell align="left">
                        {tagsData?.count > 0 ? (
                          <Link to={`/project-inner-detail/${params?.sessionId}/${tagsData?.flag}&socialTag?name=${tagsData?.content}&origin=${searchParams.get("origin")}`}>
                            {tagsData?.icon}
                            <Typography component="span" className="Indexabilitylink">
                              {" "}
                              {tagsData?.content}
                            </Typography>
                          </Link>
                        ) : (
                          <Box component="span" sx={BoxCss}>
                            {tagsData?.icon}
                            <Typography component="span" className="Indexability">
                              {" "}
                              {tagsData?.content}
                            </Typography>
                          </Box>
                        )}
                      </StyledTableCell>
                      <StyledTableCell align="right">{tagsData?.count}</StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: priorityColor,
                          }}
                        >
                          {tagsData?.changeCount}
                          {totalRemoved < totalAdded ? (
                            <ArrowDropUpIcon style={{ color: priorityColor }} />
                          ) : totalRemoved > totalAdded ? (
                            <ArrowDropDownIcon style={{ color: priorityColor }} />
                          ) : null}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: tagsData?.addIssue > 0 ? "red" : tagsData?.addIssue < 0 ? "green" : "inherit",
                          }}
                        >
                          {tagsData?.addIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: tagsData?.newIssue > 0 ? "red" : "inherit",
                          }}
                        >
                          {tagsData?.newIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: tagsData?.removeIssue > 0 ? "green" : tagsData?.removeIssue < 0 ? "red" : "inherit",
                          }}
                        >
                          {tagsData?.removeIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">—</StyledTableCell>

                      <StyledTableCell align="right">
                        <HelpIcon
                          onClick={() =>
                            handleOpen({
                              flag: tagsData?.flag,
                              viewLink: `/project-inner-detail/${params.sessionId}/${tagsData?.flag}&socialTag?name=${tagsData?.content}&origin=${searchParams.get("origin")}`,
                              val: tagsData?.count,
                            })
                          }
                          className="HelperIconStyle"
                        />
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <Popup flag={`${tagsData?.flag}&socialTag`} refresh={refresh} issueBtnIndx={issueBtnIndx} updateFlag={tagsData?.flag} />
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
              {duplicatePageCount?.length > 0 && <Typography component="h5">Duplicates</Typography>}
              {duplicatePageCount &&
                duplicatePageCount.map(tagsData => {
                  const totalAdded = validateNumber(tagsData?.addIssue || 0) + validateNumber(tagsData?.newIssue || 0);
                  const totalRemoved = validateNumber(tagsData?.removeIssue || 0);

                  const priorityColor = totalRemoved > totalAdded ? "green" : totalRemoved < totalAdded ? "red" : "inherit";
                  return (
                    <StyledTableRow key={Math.random().toString(36).substr(2, 9)}>
                      <StyledTableCell align="left">
                        {tagsData?.count > 0 ? (
                          <Link to={`/project-inner-detail/${params?.sessionId}/${tagsData?.flag}?name=${tagsData?.content}&origin=${searchParams.get("origin")}`}>
                            {tagsData?.icon}
                            <Typography component="span" className="Indexabilitylink">
                              {" "}
                              {tagsData?.content}
                            </Typography>
                          </Link>
                        ) : (
                          <Box component="span" sx={BoxCss}>
                            {tagsData?.icon}
                            <Typography component="span" className="Indexability">
                              {" "}
                              {tagsData?.content}
                            </Typography>
                          </Box>
                        )}
                      </StyledTableCell>

                      <StyledTableCell align="right">{tagsData?.count}</StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: priorityColor,
                          }}
                        >
                          {tagsData?.changeCount}
                          {totalRemoved < totalAdded ? (
                            <ArrowDropUpIcon style={{ color: priorityColor }} />
                          ) : totalRemoved > totalAdded ? (
                            <ArrowDropDownIcon style={{ color: priorityColor }} />
                          ) : null}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: tagsData?.addIssue > 0 ? "red" : tagsData?.addIssue < 0 ? "green" : "inherit",
                          }}
                        >
                          {tagsData?.addIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: tagsData?.newIssue > 0 ? "red" : "inherit",
                          }}
                        >
                          {tagsData?.newIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: tagsData?.removeIssue > 0 ? "green" : tagsData?.removeIssue < 0 ? "red" : "inherit",
                          }}
                        >
                          {tagsData?.removeIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">—</StyledTableCell>

                      <StyledTableCell align="right">
                        <HelpIcon
                          onClick={() =>
                            handleOpen({
                              flag: tagsData?.flag,
                              viewLink: `/project-inner-detail/${params.sessionId}/${tagsData?.flag}&socialTag?name=${tagsData?.content}&origin=${searchParams.get("origin")}`,
                              val: tagsData?.count,
                            })
                          }
                          className="HelperIconStyle"
                        />
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <Popup flag={tagsData?.flag} refresh={refresh} issueBtnIndx={issueBtnIndx} updateFlag={tagsData?.flag} />
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
              {imageTagCountPrepaired?.length > 0 && <Typography component="h5">Images</Typography>}
              {imageTagCountPrepaired &&
                imageTagCountPrepaired.map(imgData => {
                  const totalAdded = validateNumber(imgData?.addIssue || 0) + validateNumber(imgData?.newIssue || 0);
                  const totalRemoved = validateNumber(imgData?.removeIssue || 0);

                  const priorityColor = totalRemoved > totalAdded ? "green" : totalRemoved < totalAdded ? "red" : "inherit";
                  return (
                    <StyledTableRow key={Math.random().toString(36).substr(2, 9)}>
                      <StyledTableCell align="left">
                        {imgData?.count > 0 ? (
                          <Link to={`/project-inner-detail/${params.sessionId}/${imgData?.flag}&imagesFlag?name=${imgData?.content}&origin=${searchParams.get("origin")}`}>
                            {imgData?.icon}
                            <Typography component="span" className="Indexabilitylink">
                              {" "}
                              {imgData?.content}
                            </Typography>
                          </Link>
                        ) : (
                          <Box component="span" sx={BoxCss}>
                            {imgData?.icon}
                            <Typography component="span" className="Indexability">
                              {" "}
                              {imgData?.content}
                            </Typography>
                          </Box>
                        )}
                      </StyledTableCell>

                      <StyledTableCell align="right">{imgData?.count}</StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: priorityColor,
                          }}
                        >
                          {imgData?.changeCount}
                          {totalRemoved < totalAdded ? (
                            <ArrowDropUpIcon style={{ color: priorityColor }} />
                          ) : totalRemoved > totalAdded ? (
                            <ArrowDropDownIcon style={{ color: priorityColor }} />
                          ) : null}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: imgData?.addIssue > 0 ? "red" : imgData?.addIssue < 0 ? "green" : "inherit",
                          }}
                        >
                          {imgData?.addIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: imgData?.newIssue > 0 ? "red" : "inherit",
                          }}
                        >
                          {imgData?.newIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: imgData?.removeIssue > 0 ? "green" : imgData?.removeIssue < 0 ? "red" : "inherit",
                          }}
                        >
                          {imgData?.removeIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">—</StyledTableCell>

                      <StyledTableCell align="right">
                        <HelpIcon
                          onClick={() =>
                            handleOpen({
                              flag: imgData?.flag,
                              viewLink: `/project-inner-detail/${params.sessionId}/${imgData?.flag}&imagesFlag?name=${imgData?.content}`,
                              val: imgData?.count,
                            })
                          }
                          className="HelperIconStyle"
                        />
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <Popup flag={`${imgData?.flag}&imagesFlag`} refresh={refresh} issueBtnIndx={issueBtnIndx} updateFlag={imgData?.flag} />
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
              {jsCountPrepaired?.length > 0 && <Typography component="h5">JavaScript</Typography>}
              {jsCountPrepaired &&
                jsCountPrepaired.map(jsData => {
                  const totalAdded = validateNumber(jsData?.addIssue || 0) + validateNumber(jsData?.newIssue || 0);
                  const totalRemoved = validateNumber(jsData?.removeIssue || 0);

                  const priorityColor = totalRemoved > totalAdded ? "green" : totalRemoved < totalAdded ? "red" : "inherit";
                  return (
                    <StyledTableRow key={Math.random().toString(36).substr(2, 9)}>
                      <StyledTableCell align="left">
                        {jsData?.count > 0 ? (
                          <Link to={`/project-inner-detail/${params.sessionId}/${jsData?.flag}&jsFlags?name=${jsData?.content}&origin=${searchParams.get("origin")}`}>
                            {jsData?.icon}
                            <Typography component="span" className="Indexabilitylink">
                              {" "}
                              {jsData?.content}
                            </Typography>
                          </Link>
                        ) : (
                          <Box component="span" sx={BoxCss}>
                            {jsData?.icon}
                            <Typography component="span" className="Indexability">
                              {" "}
                              {jsData?.content}
                            </Typography>
                          </Box>
                        )}
                      </StyledTableCell>

                      <StyledTableCell align="right">{jsData?.count}</StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: priorityColor,
                          }}
                        >
                          {jsData?.changeCount}
                          {totalRemoved < totalAdded ? (
                            <ArrowDropUpIcon style={{ color: priorityColor }} />
                          ) : totalRemoved > totalAdded ? (
                            <ArrowDropDownIcon style={{ color: priorityColor }} />
                          ) : null}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: jsData?.addIssue > 0 ? "red" : jsData?.addIssue < 0 ? "green" : "inherit",
                          }}
                        >
                          {jsData?.addIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: jsData?.newIssue > 0 ? "red" : "inherit",
                          }}
                        >
                          {jsData?.newIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: jsData?.removeIssue > 0 ? "green" : jsData?.removeIssue < 0 ? "red" : "inherit",
                          }}
                        >
                          {jsData?.removeIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">—</StyledTableCell>

                      <StyledTableCell align="right">
                        <HelpIcon
                          onClick={() =>
                            handleOpen({
                              flag: jsData?.flag,
                              viewLink: `/project-inner-detail/${params.sessionId}/${jsData?.flag}&jsFlags?name=${jsData?.content}`,
                              val: jsData?.count,
                            })
                          }
                          className="HelperIconStyle"
                        />
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <Popup flag={`${jsData?.flag}&jsFlags`} refresh={refresh} issueBtnIndx={issueBtnIndx} updateFlag={jsData?.flag} />
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
              {cssTagCountPrepaired?.length > 0 && <Typography component="h5">CSS</Typography>}
              {cssTagCountPrepaired &&
                cssTagCountPrepaired.map(cssData => {
                  const totalAdded = validateNumber(cssData?.addIssue || 0) + validateNumber(cssData?.newIssue || 0);
                  const totalRemoved = validateNumber(cssData?.removeIssue || 0);

                  const priorityColor = totalRemoved > totalAdded ? "green" : totalRemoved < totalAdded ? "red" : "inherit";
                  return (
                    <StyledTableRow key={Math.random().toString(36).substr(2, 9)}>
                      <StyledTableCell align="left">
                        {cssData?.count > 0 ? (
                          <Link to={`/project-inner-detail/${params?.sessionId}/${cssData?.flag}&cssFlags?name=${cssData?.content}&origin=${searchParams.get("origin")}`}>
                            {cssData?.icon}
                            <Typography component="span" className="Indexabilitylink">
                              {" "}
                              {cssData?.content}
                            </Typography>
                          </Link>
                        ) : (
                          <Box component="span" sx={BoxCss}>
                            {cssData?.icon}
                            <Typography component="span" className="Indexability">
                              {" "}
                              {cssData?.content}
                            </Typography>
                          </Box>
                        )}
                      </StyledTableCell>

                      <StyledTableCell align="right">{cssData?.count}</StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: priorityColor,
                          }}
                        >
                          {cssData?.changeCount}
                          {totalRemoved < totalAdded ? (
                            <ArrowDropUpIcon style={{ color: priorityColor }} />
                          ) : totalRemoved > totalAdded ? (
                            <ArrowDropDownIcon style={{ color: priorityColor }} />
                          ) : null}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: cssData?.addIssue > 0 ? "red" : cssData?.addIssue < 0 ? "green" : "inherit",
                          }}
                        >
                          {cssData?.addIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: cssData?.newIssue > 0 ? "red" : "inherit",
                          }}
                        >
                          {cssData?.newIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: cssData?.removeIssue > 0 ? "green" : cssData?.removeIssue < 0 ? "red" : "inherit",
                          }}
                        >
                          {cssData?.removeIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">—</StyledTableCell>

                      <StyledTableCell align="right">
                        <HelpIcon
                          onClick={() =>
                            handleOpen({
                              flag: cssData?.flag,
                              viewLink: `/project-inner-detail/${params?.sessionId}/${cssData?.flag}&cssFlags?name=${cssData?.content}`,
                              val: cssData?.count,
                            })
                          }
                          className="HelperIconStyle"
                        />
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <Popup flag={`${cssData?.flag}&cssFlags`} refresh={refresh} issueBtnIndx={issueBtnIndx} updateFlag={cssData?.flag} />
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
              {externalPagesCountPrepaired?.length > 0 && <Typography component="h5">External pages</Typography>}
              {externalPagesCountPrepaired &&
                externalPagesCountPrepaired.map(externalPage => {
                  const totalAdded = validateNumber(externalPage?.addIssue || 0) + validateNumber(externalPage?.newIssue || 0);
                  const totalRemoved = validateNumber(externalPage?.removeIssue || 0);

                  const priorityColor = totalRemoved > totalAdded ? "green" : totalRemoved < totalAdded ? "red" : "inherit";
                  return (
                    <StyledTableRow key={Math.random().toString(36).substr(2, 9)}>
                      <StyledTableCell align="left">
                        {externalPage?.count > 0 ? (
                          <Link
                            to={`/project-inner-detail/${params?.sessionId}/${externalPage?.flag}&externalPagesFlag?name=${externalPage?.content}&origin=${searchParams.get(
                              "origin",
                            )}`}
                          >
                            {externalPage?.icon}
                            <Typography component="span" className="Indexabilitylink">
                              {" "}
                              {externalPage?.content}
                            </Typography>
                          </Link>
                        ) : (
                          <Box component="span" sx={BoxCss}>
                            {externalPage?.icon}
                            <Typography component="span" className="Indexability">
                              {" "}
                              {externalPage?.content}
                            </Typography>
                          </Box>
                        )}
                      </StyledTableCell>
                      <StyledTableCell align="right">{externalPage?.count}</StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: priorityColor,
                          }}
                        >
                          {externalPage?.changeCount}
                          {totalRemoved < totalAdded ? (
                            <ArrowDropUpIcon style={{ color: priorityColor }} />
                          ) : totalRemoved > totalAdded ? (
                            <ArrowDropDownIcon style={{ color: priorityColor }} />
                          ) : null}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: externalPage?.addIssue > 0 ? "red" : externalPage?.addIssue < 0 ? "green" : "inherit",
                          }}
                        >
                          {externalPage?.addIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: externalPage?.newIssue > 0 ? "red" : "inherit",
                          }}
                        >
                          {externalPage?.newIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">
                        <Typography
                          style={{
                            color: externalPage?.removeIssue > 0 ? "green" : externalPage?.removeIssue < 0 ? "red" : "inherit",
                          }}
                        >
                          {externalPage?.removeIssue}
                        </Typography>
                      </StyledTableCell>

                      <StyledTableCell align="right">—</StyledTableCell>

                      <StyledTableCell align="right">
                        <HelpIcon
                          onClick={() =>
                            handleOpen({
                              flag: externalPage?.flag,
                              viewLink: `/project-inner-detail/${params?.sessionId}/${externalPage?.flag}&externalPagesFlag?name=${externalPage?.content}&origin=${searchParams.get(
                                "origin",
                              )}`,
                              val: externalPage?.count,
                            })
                          }
                          className="HelperIconStyle"
                        />
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <Popup flag={`${externalPage?.flag}&externalPagesFlag`} refresh={refresh} issueBtnIndx={issueBtnIndx} updateFlag={externalPage?.flag} />
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
              <Modal open={newState.open} onClose={handleClose}>
                <Modelstyle>
                  <CancelIcon onClick={handleClose} />
                  <ProjectHelperDetail flag={newState?.flag} viewLink={newState?.viewLink} val={newState?.val} />
                </Modelstyle>
              </Modal>
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </TableMainWrapper>
  );
}
export default ProjectDetailData;
